import { render, staticRenderFns } from "./groupbusy.vue?vue&type=template&id=0cff18f7&scoped=true&"
import script from "./groupbusy.vue?vue&type=script&lang=js&"
export * from "./groupbusy.vue?vue&type=script&lang=js&"
import style0 from "./groupbusy.vue?vue&type=style&index=0&id=0cff18f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff18f7",
  null
  
)

export default component.exports